export default "__VITE_ASSET__bdf8eed3__"